export default __webpack_public_path__ + "static/media/export-icon.d59c2656.svg";